export const en = {
  brandShort: "Daaru Na'im",
  brandOrg: "Daaru Na'im Academy for Shariah Sciences of Nigeria",
  conferenceEdition: "18th Annual International Conference",
  nav: {
    home: "Home",
    cfp: "Call for Papers",
    schedule: "Schedule",
    venue: "Venue",
    papers: "Papers",
    pastEvents: "Past Events",
    register: "Register",
    login: "Login",
    dashboard: "Dashboard",
    myPapers: "My Papers",
    submit: "Submit Paper",
    reviews: "Reviews",
    admin: "Admin",
    adminWorkspace: "Admin workspace",
    participantWorkspace: "Participant workspace",
    adminOverview: "Overview",
    adminRegistrations: "Registrations",
    adminReviewers: "Reviewers",
    adminPapers: "Papers",
    adminPastEvents: "Past Events",
    adminSessions: "Sessions",
    adminCorrespondence: "Correspondence",
    adminMessages: "Messages",
    adminCertificates: "Certificates",
    adminReminders: "Reminder Emails",
    adminSettings: "Conference Settings",
    viewPublicSite: "View Public Site",
    accountSecurity: "Account / Security",
    logout: "Log out",
    language: "Language",
    langEn: "EN",
    langAr: "العربية",
    langFr: "FR",
  },
  pastEvents: {
    title: "Past Events",
    lead: "Browse archived Academy publications and past event materials.",
    year: "Year",
    view: "View",
    downloadPdf: "Download PDF",
    openPdf: "Open PDF",
    openFullscreen: "Open PDF in a new tab",
    pdfUnavailable: "PDF not yet available",
    backToArchive: "Back to Past Events",
    emptyTitle: "No past events published yet",
    emptyBody: "Published archive items will appear here.",
  },
  hero: {
    ctaRegister: "Register for Conference",
    ctaSubmit: "Submit a Paper",
    countdown: "Countdown to conference",
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
  },
  sections: {
    about: "About the Conference",
    aboutBody:
      "An international scholarly gathering convened by Daaru Na'im Academy for Shariah Sciences of Nigeria to explore the jurisprudence of Muslim relations with others in light of the Shariah.",
    theme: "Conference Theme",
    dates: "Important Dates",
    abstractDeadline: "Abstract deadline",
    paperDeadline: "Full paper deadline",
    conferenceDates: "International conference",
    nationalOptional: "National conference (optional / pre-conference)",
    cfp: "Call for Papers",
    cfpBody: "Scholars are invited to submit abstracts and full papers in Arabic, English, or French.",
    topics: "Suggested Topics",
    guidelines: "Submission Guidelines",
    programme: "Conference Programme",
    live: "Live Stream",
    papersArchive: "Papers / Conference Archive",
    papersArchiveBody:
      "Browse scholarly papers across Daaru Na'im conference editions, including curated open-access samples.",
    browseAllPapers: "Browse All Papers",
    submittedPapers: "Papers / Conference Archive",
    submittedPapersBody:
      "Browse scholarly papers across Daaru Na'im conference editions, including curated open-access samples.",
    viewAllPapers: "Browse All Papers",
    venue: "Venue & Contact",
    organizer: "Organizer",
    director: "Director-General",
    contact: "Contact",
    finalCta: "Join the Conference",
    finalCtaBody: "Register now and submit your paper. Physical conference cards are issued at the venue.",
  },
  guidelines: {
    languages: "Accepted languages: Arabic, English, or French",
    arabicFont: "Arabic: Traditional Arabic, 18 pt",
    englishFont: "English: Times New Roman, 12 pt",
    frenchFont: "French: Times New Roman, 12 pt",
    format: "Submit as Microsoft Word (.doc / .docx)",
  },
  register: {
    title: "Conference Registration",
    subtitle: "Create your participant account and receive a registration confirmation.",
    email: "Email",
    password: "Password",
    confirm: "Confirm password",
    fullName: "Full name",
    fullNameAr: "Full name (Arabic, optional)",
    phone: "Phone / WhatsApp",
    country: "Country",
    city: "City (optional)",
    institution: "Institution / Affiliation",
    role: "Academic / professional title",
    preferredLang: "Preferred language",
    organization: "Organization (optional)",
    notes: "Notes (optional)",
    passiCode: "Passi retrieval code",
    passiCreateLink: "Open Passi",
    passiInstructionsTitle: "How do I get my Passi retrieval code?",
    passiSummarySteps:
      "1. Open Passi and click Start creating\n2. Choose Generic portrait (1200×1200 square)\n3. Upload a photo or use the camera\n4. Confirm, crop/adjust, then finish Final checks\n5. Click Stage and generate retrieval code, then Confirm and upload\n6. Copy the 6-character retrieval code (not the delete secret)\n7. Return here and paste it into this field",
    passiOptionalNote:
      "A photo is optional. You may complete registration without a Passi retrieval code.",
    passiOpenGuide: "Open visual step-by-step guide",
    passiGuideOpensNewTab: "Opens in a new tab so your registration form stays filled in.",
    submit: "Complete registration",
    success: "Registration successful",
    successBody:
      "Your registration has been completed successfully. A confirmation email has been sent to your email address. Please note that delivery may take a few minutes. If you do not see the email in your inbox, please check your Spam or Junk folder.",
    code: "Registration code",
    cardAtVenueNote:
      "Your physical conference card will be issued when you arrive at the conference.",
    goDashboard: "Go to dashboard",
  },
  passiGuide: {
    eyebrow: "Photo help",
    title: "Passi visual step-by-step guide",
    intro:
      "Follow these screenshots to create a conference portrait in Passi and copy a 6-character retrieval code for Daaru Na'im registration.",
    optionalNote:
      "Adding a photo is optional. You can register for the conference without a Passi retrieval code.",
    openPassi: "Open Passi",
    returnRegister: "Return to registration",
    copyCodeNotSecret:
      "Important: copy the 6-character retrieval code only — not the longer delete secret.",
    step1Title: "Open Passi and start",
    step1Body: "Go to passi.fingletek.com and click the green Start creating button.",
    step1Callout: "Click Start creating",
    step2Title: "You are in Create photo",
    step2Body: "Passi opens the template list. You will choose a generic conference portrait next.",
    step3Title: "Choose Generic portrait (1200×1200 square)",
    step3Body:
      "Find the card Generic portrait (1200×1200 square) and click Select this template. Do not pick a passport/visa template.",
    step3Callout: "Select this template",
    step4Title: "Upload a photo or use the camera",
    step4Body: "Choose Upload photo to pick a file from your device, or Use camera capture to take a new picture.",
    step4Callout: "Upload photo or Use camera",
    step5Title: "Confirm your photo",
    step5Body: "Check the preview, then continue/confirm so Passi can move to cropping and editing.",
    step5Callout: "Confirm / continue",
    step6Title: "Adjust and crop the portrait",
    step6Body: "Drag to centre your face, zoom if needed, then continue to Final checks.",
    step6Callout: "Continue after crop",
    step7Title: "Review Final checks",
    step7Body: "Read the automatic checks. Warnings are OK for a conference portrait — continue to staging.",
    step8Title: "Stage and generate retrieval code",
    step8Body: "Scroll to Stage for retrieval and click Stage and generate retrieval code.",
    step8Callout: "Stage and generate retrieval code",
    step9Title: "Confirm the upload",
    step9Body: "Passi asks you to confirm staging. Click Confirm and upload.",
    step9Callout: "Confirm and upload",
    step10Title: "Find your 6-character retrieval code",
    step10Body:
      "The short retrieval code appears under Stage for retrieval. This is what Daaru Na'im needs.",
    step10Callout: "Retrieval code (6 characters)",
    step11Title: "Copy the retrieval code",
    step11Body:
      "Click Copy next to the retrieval code. Do not copy the delete secret underneath it.",
    step11Callout: "Copy retrieval code",
    step12Title: "Return to Daaru Na'im registration",
    step12Body:
      "Go back to your registration browser tab, paste the code into Passi retrieval code, and continue registration. Your form fields should still be there.",
  },
  login: {
    title: "Participant / Admin Login",
    submit: "Sign in",
    noAccount: "Need an account?",
  },
  setPassword: {
    title: "Set your password",
    lead: "Your account uses a temporary password. Choose a new password before continuing.",
    currentPassword: "Current (temporary) password",
    newPassword: "New password",
    confirmPassword: "Confirm new password",
    submit: "Save password",
  },
  accountSecurity: {
    title: "Account / Security",
    lead: "Change the password for your conference account. You will stay signed in on this device.",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm new password",
    policyHint: "Use at least 8 characters. Do not reuse your current password.",
    submit: "Update password",
    success: "Password updated successfully.",
    mismatch: "New password and confirmation do not match.",
  },
  dashboard: {
    title: "Participant Dashboard",
    registration: "Conference Registration",
    registered: "Registered",
    badge: "My Badge",
    cardAtVenue: "Conference card",
    cardAtVenueHelp:
      "Physical cards are issued at check-in. Digital badge download is not available.",
    papers: "My Papers",
    schedule: "Conference Schedule",
    liveNow: "Live Now",
    profile: "Profile",
    noPapers: "No papers submitted yet",
    submitPaper: "Submit a paper",
    reviews: "Reviews",
    reviewsHelp: "Papers assigned to you for conference peer review.",
    openReviews: "Open Reviews",
    editorialDecision: "Editorial decision",
    submitRevisedPaper: "Submit Revised Paper",
    submitRevision: "Submit revision",
    revisionFile: "Revised manuscript (.doc / .docx)",
    revisionNotes: "Response to Decision / Revision Notes",
    revisionNotesHelp: "Optional short response to the editorial decision.",
    revisionNeedFile: "Choose a .doc or .docx manuscript to upload.",
    revisionSubmitted: "Revision {n} submitted. Organizers have been notified.",
    revisionLabel: "rev. {n}",
  },
  reviews: {
    title: "Reviews",
    lead: "Papers assigned to you as a designated conference reviewer.",
    empty: "No papers assigned for review yet.",
    colTitle: "Title",
    colAuthors: "Authors",
    colLanguage: "Language",
    colAssigned: "Assigned",
    colDue: "Due",
    colStatus: "Status",
    statusAssigned: "Assigned",
    statusCompleted: "Completed",
    openReview: "Open review",
    viewReview: "View review",
    reviewTitle: "Paper review",
    downloadManuscript: "Download manuscript",
    noManuscript: "No manuscript on file",
    formTitle: "Your review",
    comments: "Review comments",
    recommendation: "Recommendation",
    recommendationPlaceholder: "Select a recommendation",
    recAccept: "Accept",
    recMinor: "Minor revision",
    recMajor: "Major revision",
    recReject: "Reject",
    saveDraft: "Save draft",
    submitFinal: "Submit final review",
    draftSaved: "Draft saved",
    submitted: "Review submitted",
    submitNeedFields: "Comments and a recommendation are required to submit.",
    readOnlyHelp: "This review has been submitted and is read-only unless an administrator reopens it.",
    submittedAt: "Submitted at",
  },
  paper: {
    title: "Submit a Paper",
    paperTitle: "Paper title",
    titleAlt: "Alternate title (optional)",
    language: "Language",
    abstract: "Abstract",
    keywords: "Keywords",
    authors: "Authors",
    affiliation: "Affiliation",
    file: "Paper file (.doc / .docx)",
    notes: "Notes to organizers (optional)",
    submit: "Submit paper",
    success: "Paper submitted successfully",
  },
  schedule: {
    title: "Conference Schedule",
    preliminary: "",
    watchLive: "Watch Live",
    liveNow: "LIVE NOW",
    ended: "Session ended",
    upcoming: "Streaming will be available when the session starts",
    demoTitle: "Demo live-stream preview",
    demoBody: "This is a demonstration preview — not an actual live broadcast.",
    liveStreamTitle: "Live stream",
  },
  papers: {
    title: "Papers",
    lead: "Search the scholarly papers archive across all Daaru Na'im Annual International Conference editions.",
    archiveSummary: "Papers — {conferences} Conferences",
    filteredSummary: "{papers} papers across {conferences} conferences",
    search: "Paper search",
    searchPlaceholder: "Search title, authors, affiliation, keywords, abstract…",
    clear: "Clear",
    filterLanguage: "Language",
    filterConference: "Conference",
    conferenceAll: "All conferences",
    conferenceSelected: "{count} conferences selected",
    conferenceSearch: "Search conferences…",
    clearConferences: "Clear conferences",
    langAll: "All languages",
    langEnglish: "English",
    langArabic: "Arabic",
    langFrench: "French",
    results: "{count} papers",
    emptyTitle: "No papers found",
    emptyBody: "Try a different search or clear your conference filters.",
    authors: "Authors",
    affiliation: "Affiliation",
    keywords: "Keywords",
    externalArchive: "Open-access archive / sample",
    readOnline: "Read Online",
    downloadPdf: "Download PDF",
    pdfUnavailable: "PDF not yet available",
    backToPapers: "Back to Papers",
    prev: "Previous",
    next: "Next",
    page: "Page {page} of {pages}",
  },
  status: {
    submitted: "submitted",
    under_review: "under review",
    minor_revision: "minor revision",
    major_revision: "major revision",
    revised: "revised",
    accepted: "accepted",
    rejected: "rejected",
    published: "published",
    publishedAccepted: "published-accepted",
  },
  venue: {
    title: "Venue & Contact",
    address: "Address",
    map: "Open in Maps",
    mapTitle: "Conference venue map",
    mapLoading: "Loading map…",
  },
  verify: {
    title: "Registration Verification",
    valid: "Valid registration",
    invalid: "Registration not found",
  },
  admin: {
    title: "Conference Admin",
    statsRegs: "Total Registrations",
    statsPapers: "Papers Submitted",
    statsAccepted: "Accepted Papers",
    statsUpcoming: "Upcoming Sessions",
    statsCheckedIn: "Checked In",
    registrations: "Registrations",
    papers: "Papers",
    papersLead:
      "Review → accept/reject → Prepare & Publish to release a branded PDF to the public Papers archive.",
    pastEvents: "Past Events",
    pastEventsLead: "Add, edit, publish, or archive past event PDFs for the public archive.",
    pastEventsAdd: "Add past event",
    pastEventsEdit: "Edit past event",
    pastEventsSlug: "Slug",
    pastEventsYear: "Year",
    pastEventsDate: "Event date (optional)",
    pastEventsOrder: "Display order",
    pastEventsTitleEn: "Title (English)",
    pastEventsTitleAr: "Title (Arabic)",
    pastEventsTitleFr: "Title (French)",
    pastEventsDescEn: "Description (English)",
    pastEventsDescAr: "Description (Arabic)",
    pastEventsDescFr: "Description (French)",
    pastEventsPdf: "PDF file",
    pastEventsPublished: "Published",
    pastEventsArchived: "Archived",
    pastEventsPublish: "Publish",
    pastEventsUnpublish: "Unpublish",
    pastEventsCreated: "Past event created",
    pastEventsSaved: "Past event saved",
    pastEventsDeleteConfirm: "Delete this past event record?",
    sessions: "Sessions",
    settings: "Conference Settings",
    reminders: "Reminder emails",
    remindersLead:
      "Automatic participant reminders follow the conference start date (Africa/Lagos): weekly from 2 months out, twice weekly in the final month until day 10, then daily until the event starts.",
    remindersEnabled: "Reminders enabled",
    remindersOn: "On",
    remindersOff: "Off",
    remindersEnable: "Enable reminders",
    remindersDisable: "Disable reminders",
    remindersNext: "Next scheduled reminder",
    remindersNone: "None",
    remindersTimezone: "Timezone",
    remindersTotals: "Delivery totals",
    remindersSent: "Sent",
    remindersFailed: "Failed",
    remindersEligible: "Eligible recipients",
    remindersRunNow: "Process due reminders now",
    remindersRunDone: "Reminder run finished",
    remindersTest: "Send test reminder",
    remindersTestHelp: "Sends only to the email you enter — never to the full participant list.",
    remindersTestEmail: "Controlled test email",
    remindersSendTest: "Send test",
    remindersTestSent: "Test reminder queued/sent",
    remindersRecent: "Recent sends / failures",
    remindersWindow: "Window / period",
    remindersScheduled: "Scheduled date",
    remindersSentAt: "Sent at",
    printSelected: "Download Selected Cards",
    actions: "Actions",
    sendHotelReservation: "Send Hotel Reservation",
    searchRegistrations: "Search name, email, phone, institution, country, or code…",
    cardType: "Card type",
    cardTypeParticipant: "Participant (B)",
    cardTypeHotel: "Participant + Hotel (C)",
    previewCard: "Preview Card",
    printDownloadCard: "Print / Download Card (PDF)",
    downloadCardPng: "Download card image (PNG)",
    resendRegistration: "Resend registration email",
    makeReviewer: "Make Reviewer",
    removeReviewer: "Remove Reviewer",
    reviewerBadge: "Reviewer",
    reviewers: "Reviewers",
    reviewersLead:
      "Registered participants and external reviewers designated for conference peer review. Removing reviewer rights does not delete registrations.",
    addReviewer: "Add Reviewer",
    addReviewerTitle: "Add external reviewer",
    addReviewerLead: "Creates a reviewer account and sends an invitation email (temporary password is never shown here).",
    addReviewerFullName: "Full name",
    addReviewerEmail: "Email",
    addReviewerInstitution: "Institution",
    addReviewerPhone: "Phone",
    addReviewerCountry: "Country",
    addReviewerTitleRole: "Academic title / position",
    addReviewerExpertise: "Areas of expertise / keywords",
    addReviewerLanguage: "Preferred email language",
    addReviewerSubmit: "Create reviewer",
    reviewerKind: "Type",
    reviewerKindRegistered: "Registered Participant",
    reviewerKindExternal: "External Reviewer",
    resendTempPassword: "Resend / Generate New Temporary Password",
    resendTempPasswordDone: "A new temporary password was emailed to the reviewer.",
    searchReviewers: "Search name, email, institution, or code…",
    reviewersIncludeInactive: "Include inactive",
    reviewersEmpty: "No reviewers designated yet.",
    reviewerName: "Name",
    reviewerInstitution: "Institution",
    reviewerCode: "Registration code",
    reviewerAssignedAt: "Date assigned",
    reviewerStatus: "Status",
    reviewerActive: "Active",
    reviewerInactive: "Inactive",
    assignPapers: "Assign Papers",
    assignPapersTitle: "Assign papers to reviewer",
    assignPapersLead: "Search submitted papers and assign one or more to this designated reviewer. Cancelling an assignment does not delete the paper or the reviewer.",
    assignPapersInactiveBlocked: "This reviewer is inactive and cannot receive new assignments.",
    assignPapersNeedSelection: "Select at least one paper to assign.",
    assignPapersDone: "Papers assigned",
    assignmentCancelled: "Assignment cancelled",
    currentAssignments: "Current assignments",
    noAssignments: "No active assignments yet.",
    cancelledAssignmentsCount: "{n} cancelled assignment(s) retained for history.",
    availablePapers: "Available papers",
    assignSearchPapers: "Search title, authors, keywords…",
    assignFilterLanguage: "Language",
    filterAllLanguages: "All languages",
    assignFilterEdition: "Edition #",
    assignFilterKeywords: "Keywords",
    assignDueDate: "Due date (optional)",
    assignSelectedPapers: "Assign selected papers",
    noAssignablePapers: "No matching papers available to assign.",
    cancelAssignment: "Cancel assignment",
    assignColTitle: "Title",
    assignColAuthors: "Authors",
    assignColLanguage: "Language",
    assignColAssigned: "Assigned",
    assignColDue: "Due",
    assignColEmail: "Assignment email",
    assignColReminder: "Latest reminder",
    assignColStatus: "Status",
    assignmentEmailSent: "Sent",
    assignmentEmailNotSent: "Not sent",
    resendAssignmentEmail: "Resend assignment email",
    assignmentEmailResent: "Assignment email queued for resend",
    overdue: "Overdue",
    reminderStatus7d: "7 days before",
    reminderStatus3d: "3 days before",
    reminderStatusDue: "Due-day reminder",
    assignColEdition: "Edition",
    assignColKeywords: "Keywords",
    assignColPaperStatus: "Paper status",
    viewSubmittedReview: "View review",
    viewReviewTitle: "Submitted review",
    viewReviewLead: "Read the reviewer’s recommendation and comments. Editorial accept/reject is not part of this step.",
    submittedReview: "Reviewer feedback",
    noSubmittedReview: "No submitted review yet.",
    reopenReview: "Reopen for edits",
    reviewReopened: "Review reopened for the reviewer",
    reviewDecision: "Review & Decision",
    reviewDecisionTitle: "Review & editorial decision",
    reviewDecisionLead: "Reviewer recommendations are advisory. Only Admin records the final decision for the author.",
    reviewerFeedback: "Assigned reviewers",
    pendingReviewsCount: "{completed} submitted · {pending} pending",
    noReviewersAssigned: "No reviewers assigned to this paper yet.",
    reviewPending: "Pending",
    recordDecision: "Record editorial decision",
    decisionAdvisory: "This decision is emailed to the author. Reviewer names and comments are not included unless you write them into the message.",
    decisionLabel: "Decision",
    decisionPlaceholder: "Select a decision",
    decisionAccept: "Accepted",
    decisionMinor: "Minor revision",
    decisionMajor: "Major revision",
    decisionReject: "Rejected",
    decisionMessage: "Message to author",
    decisionMessageHelp: "Shown to the author and included in the decision email.",
    forceUpdateDecision: "Confirm update of the previous decision (audit will be retained)",
    saveDecision: "Save decision",
    updateDecision: "Update decision",
    decisionSaved: "Decision saved",
    decisionNeedChoice: "Select a decision before saving.",
    currentDecision: "Current decision",
    decidedAt: "Decided at",
    decisionHistory: "Decision history",
    decisionUpdate: "update",
    manuscriptRevisions: "Manuscript revisions",
    manuscriptRevisionsHelp:
      "Full history is retained. Reviewers always receive the latest manuscript; older versions remain Admin-only.",
    currentRevision: "Current revision",
    revisionNumber: "Revision {n}",
    revisionLatest: "latest",
    downloadRevision: "Download this revision",
    generalCardsTitle: "General Participation Cards (Category A)",
    generalCardsHelp:
      "Formal general-listener cards for guests who do not register. No name, photo, or personal QR. Preview keeps the real badge aspect ratio; print PDF pages are the physical badge size.",
    generalCardsCopies: "Copies",
    previewGeneralCard: "Preview generic card (PNG)",
    downloadGeneralCards: "Download / print bulk (PDF)",
    cardSettingsHelp:
      "Card titles, crest path, and physical size (card_width_mm / card_height_mm / card_safe_margin_mm). Default crest: daarunaim/crest.png. Temporary badge preset: 80 × 120 mm with 5 mm safe margin.",
    cardPrintHelp:
      "Print PDFs at Actual Size / 100% (do not fit to page). PNG exports are 300 DPI from the same layout.",
    closePreview: "Close preview",
    badgePreviewTitle: "Badge preview",
    hotelTitle: "Hotel reservation",
    hotelLead:
      "Compose and email hotel booking details to this registered participant only. The recipient is fixed to their registration email.",
    hotelRecipient: "Recipient (fixed)",
    hotelRecipientFixed: "This email always goes to the selected registrant — the recipient cannot be changed here.",
    hotelCode: "Registration code",
    hotelLanguage: "Preferred language",
    hotelStatus: "Reservation status",
    hotelLastSent: "Last sent",
    hotelName: "Hotel name",
    hotelAddress: "Hotel address / location",
    hotelCheckIn: "Check-in date",
    hotelCheckOut: "Check-out date",
    hotelBookingRef: "Reservation / booking reference",
    hotelRoomType: "Room type",
    hotelRoomNumber: "Room number",
    hotelRoomNumberHelp: "Shown prominently on the hotel-access card",
    hotelContactPhone: "Contact phone",
    hotelMapsUrl: "Google Maps / location URL (optional)",
    hotelNotes: "Notes / instructions",
    hotelSave: "Save draft",
    hotelSaved: "Hotel reservation saved",
    hotelPreview: "Preview email",
    hotelSend: "Send reservation email",
    hotelResend: "Resend / update email",
    hotelSent: "Hotel reservation email sent",
    hotelTo: "To",
    hotelHistory: "Delivery history",
    markLive: "Mark LIVE",
    markEnded: "Mark Ended",
    downloadBadge: "Download card",
    checkIn: "Mark checked in",
    resend: "Resend registration email",
    changeStatus: "Update status",
    save: "Save settings",

    correspondence: "Correspondence / Messages",
    correspondenceLead:
      "Compose Academy formal letters section by section. Recipient selection is only for delivery — letter text is never auto-generated from the selected name.",
    messages: "Messages",
    messagesLead:
      "Send a direct branded email to any valid address. This does not create a user, registration, or reviewer record.",
    msgCompose: "Compose email",
    msgComposeHelp:
      "Your subject and message are sent as written, wrapped in the Academy green email template.",
    msgRecipientEmail: "Recipient email",
    msgSubject: "Subject",
    msgBody: "Message body",
    msgSend: "Send email",
    msgSending: "Sending…",
    msgSent: "Email sent successfully.",
    msgNeedEmail: "Recipient email is required.",
    msgNeedSubject: "Subject is required.",
    msgNeedBody: "Message body is required.",
    msgInvalidEmail: "Enter a valid email address.",
    msgHistory: "Recent messages",
    msgHistoryLead: "Delivery history from the conference email ledger.",
    msgHistoryEmpty: "No messages sent yet.",
    msgColRecipient: "Recipient",
    msgColSubject: "Subject",
    msgColSentAt: "Sent",
    corrHistory: "Correspondence history",
    corrHistoryLead: "Search prior letters, re-download the exact PDF, or resend individually.",
    corrSearchRecipients: "Search recipients",
    corrSearchPlaceholder: "Name, email, or type…",
    corrNoRecipients: "No matching recipients (admins are excluded).",
    corrNeedRecipients: "Select at least one recipient.",
    corrNeedTitle: "Enter the subject.",
    corrNeedBody: "Enter the message body.",
    corrNeedAddressee: "Enter the recipient heading / addressee.",
    corrPlainSectionInvalid: "Use letters, numbers, spaces, commas, and periods only (no symbols like / or -).",
    corrFixRequired: "Please complete the required fields before continuing.",
    corrRequired: "Required",
    corrRecipientsHeading: "Recipients",
    corrComposeHeading: "Letter sections",
    corrComposeHint:
      "Fields appear in letter order. Required fields are marked with a red asterisk.",
    corrSelectedNone: "None selected",
    corrSelectedCount: "{count} selected",
    corrSelect: "Select",
    corrRemoveRecipient: "Remove recipient",
    corrRecipient: "Recipient",
    corrType: "Type",
    corrTypeParticipant: "Participant",
    corrTypeRegisteredReviewer: "Registered Reviewer",
    corrTypeExternalReviewer: "External Reviewer",
    corrExternalHeading: "Unregistered recipients",
    corrExternalHelp:
      "Add any valid email to send the same signed letter — no registration or user account is created.",
    corrExternalEmail: "External email",
    corrExternalName: "Display name (optional)",
    corrExternalNamePlaceholder: "Recipient name for the email greeting",
    corrExternalAdd: "Add email",
    corrTypeExternal: "Unregistered",
    corrAddressee: "Recipient heading / Addressee",
    corrAddresseePlaceholder: "e.g. His Eminence Sheikh Dr. Abdel Rahim Al-Atri",
    corrPrayerHonorific: "Prayer / honorific phrase",
    corrPrayerHonorificPlaceholder: "e.g. May Allah protect and preserve you",
    corrLocation: "Location / Institution / Country",
    corrLocationPlaceholder: "e.g. Kingdom of Morocco",
    corrGreeting: "Greeting / Salutation",
    corrGreetingPlaceholder: "e.g. Peace be upon you",
    corrTitle: "Subject",
    corrTitlePlaceholder: "Subject text (الموضوع is added automatically for Arabic)",
    corrBody: "Message body",
    corrRteBold: "Bold",
    corrRteItalic: "Italic",
    corrRteUnderline: "Underline",
    corrRteAlignLeft: "Align left",
    corrRteAlignCenter: "Align center",
    corrRteAlignRight: "Align right",
    corrRteAlignJustify: "Justify",
    corrRteBulletList: "Bulleted list",
    corrRteOrderedList: "Numbered list",
    corrRteUndo: "Undo",
    corrRteRedo: "Redo",
    corrRteFontSize: "Font size",
    corrClosing: "Closing",
    corrClosingPlaceholder: "e.g. Yours sincerely",
    corrDate: "Letter date",
    corrPreviewPdf: "Preview PDF",
    corrPreviewing: "Preparing preview…",
    corrSend: "Send",
    corrSending: "Sending…",
    corrPreviewReady: "PDF preview opened in a new tab.",
    corrSendSuccessOne: "Message sent successfully to {name}.",
    corrSendSuccessMany: "Message sent successfully to {count} recipients.",
    corrSendPartial:
      "Partial send: {sent} delivered, {failed} failed. Open Correspondence history to inspect and resend.",
    corrSendAllFailed: "Send failed for all {failed} recipient(s). Open Correspondence history to inspect.",
    corrNoticeSuccess: "Success",
    corrNoticeError: "Error",
    corrViewHistory: "Open correspondence history",
    corrSearchHistory: "Search recipient or title",
    corrDateFrom: "From",
    corrDateTo: "To",
    corrFilter: "Filter",
    corrCreated: "Created",
    corrDownload: "Download PDF",
    corrResend: "Resend",
    corrResendDone: "Letter resent",
    corrHistoryEmpty: "No correspondence yet.",
    corrStatusAll: "All statuses",
    corrStatusGenerated: "Generated",
    corrStatusSent: "Sent",
    corrStatusFailed: "Failed",

    certificates: "Certificates",
    certificatesLead:
      "Issue Certificates of Participation for registered participants and reviewers. Administrators are never selectable as recipients.",
    certHistory: "Certificate history",
    certHistoryLead: "Search prior certificates, re-download the exact PDF, or resend individually.",
    certSearchRecipients: "Search recipients",
    certSearchPlaceholder: "Name, email, or type…",
    certNoRecipients: "No matching recipients (admins are excluded).",
    certNeedRecipients: "Select at least one recipient.",
    certFixRequired: "Please select at least one recipient before continuing.",
    certRequired: "Required",
    certRecipientsHeading: "Recipients",
    certOptionsHeading: "Options",
    certSelectedNone: "None selected",
    certSelectedCount: "{count} selected",
    certSelect: "Select",
    certRemoveRecipient: "Remove recipient",
    certRecipient: "Recipient",
    certType: "Type",
    certLanguage: "Language",
    certLanguageAuto: "Auto (recipient preference)",
    certLanguageEn: "English",
    certLanguageAr: "Arabic",
    certLanguageFr: "French",
    certLanguageAll: "All languages",
    certNotes: "Notes (optional)",
    certPersonalize: "Per-recipient wording",
    certPersonalizeLead:
      "Set title/honorific, display name, and an optional short appreciation for each recipient. Prefills from registration title when available.",
    certHonorific: "Honorific / title",
    certHonorificNone: "None",
    certHonorificSheikh: "Sheikh",
    certHonorificDr: "Dr.",
    certHonorificSheikhDr: "Sheikh Dr.",
    certHonorificMr: "Mr.",
    certHonorificSheikhAr: "الشيخ",
    certHonorificDrAr: "الدكتور",
    certHonorificSheikhDrAr: "الشيخ الدكتور",
    certHonorificCustom: "Custom…",
    certHonorificCustomValue: "Custom title",
    certRecipientName: "Recipient name on certificate",
    certAppreciation: "Appreciation / additional message (optional)",
    certAppreciationPlaceholder: "Short personalized line shown under the name…",
    certPreviewThisRecipient: "Use for Preview",
    certPreviewPdf: "Preview PDF",
    certPreviewing: "Preparing preview…",
    certSend: "Send",
    certSending: "Sending…",
    certPreviewReady: "PDF preview opened in a new tab.",
    certSendSuccessOne: "Certificate sent successfully to {name}.",
    certSendSuccessMany: "Certificate sent successfully to {count} recipients.",
    certSendPartial:
      "Partial send: {sent} delivered, {failed} failed. Open Certificate history to inspect and resend.",
    certSendAllFailed: "Send failed for all {failed} recipient(s). Open Certificate history to inspect.",
    certNoticeSuccess: "Success",
    certNoticeError: "Error",
    certViewHistory: "Open certificate history",
    certSearchHistory: "Search recipient or notes",
    certDateFrom: "From",
    certDateTo: "To",
    certFilter: "Filter",
    certCreated: "Created",
    certDownload: "Download PDF",
    certResend: "Resend",
    certResendDone: "Certificate resent",
    certHistoryEmpty: "No certificates yet.",
    certStatusAll: "All statuses",
    certStatusGenerated: "Generated",
    certStatusSent: "Sent",
    certStatusFailed: "Failed",

    saved: "Saved",
    search: "Search…",
    filterAll: "All",
    colTitle: "Title",
    colAuthor: "Author",
    colLanguage: "Language",
    colSubmitted: "Submitted",
    colStatus: "Status",
    colFile: "File",
    colWorkflow: "Workflow",
    preparePublish: "Prepare & Publish",
    editPublication: "Edit publication",
    publishTitle: "Publish paper",
    publishLead:
      "Enrich the accepted manuscript with conference branding and publication metadata, preview the PDF, then release it to the public Papers archive. The author Word file stays private.",
    publishNeedAccept: "Accept the paper first (status = accepted) before publishing.",
    publishSuccess: "Published to the public Papers archive.",
    currentStatus: "Current status",
    publicYes: "public archive",
    viewPdf: "View PDF",
    manuscript: "Author manuscript",
    downloadWord: "Download Word manuscript",
    viewPublicPdf: "View public PDF",
    fieldTitle: "Title",
    fieldTitleAlt: "Alternate title",
    fieldAuthors: "Authors",
    fieldAffiliation: "Affiliation(s)",
    fieldAbstract: "Abstract",
    fieldKeywords: "Keywords",
    fieldAcknowledgements: "Acknowledgements",
    fieldLicense: "License",
    includeLogo: "Include Daaru Na'im conference logo on the branded PDF cover",
    uploadCameraReady: "Optional camera-ready PDF upload",
    uploadCameraReadyHelp:
      "If provided, this PDF is published as-is. Otherwise the platform generates a branded PDF from the fields above (logo, affiliations, DOI, ISBN, acknowledgements, abstract).",
    previewPdf: "Preview branded PDF",
    publishNow: "Publish to archive",
  },
  common: {
    loading: "Loading…",
    error: "Something went wrong",
    back: "Back",
    view: "View",
    download: "Download",
    print: "Print",
    close: "Close",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    mainNav: "Main",
    poweredBy: "Powered by",
    copyrightFingletek: "© Fingletek",
    fingletekPhone: "+358 44 0685538",
    skipToContent: "Skip to content",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    pageOf: "Page {page} of {pages}",
    previousPage: "Previous",
    nextPage: "Next",
    rowsPerPage: "Rows per page",
    showingCount: "Showing {from}–{to} of {total}",
  },
};

type DeepString<T> = { [K in keyof T]: T[K] extends string ? string : DeepString<T[K]> };
export type Messages = DeepString<typeof en>;
